import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NotificationListModule } from '@portal-core/notifications/components/notification-list/notification-list.module';
import { ProjectChecklistNotificationListComponent } from '@portal-core/project-checklists/components/project-checklist-notification-list/project-checklist-notification-list.component';

@NgModule({
  declarations: [
    ProjectChecklistNotificationListComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatProgressBarModule,
    NotificationListModule
  ],
  exports: [
    ProjectChecklistNotificationListComponent
  ]
})
export class ProjectChecklistNotificationListModule { }
